<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">

        <el-col
          :span="24"
          style="margin-bottom: 10px;"
        >
          <span class="title">手机号:</span>

          <el-input
            v-model="search_data.phone"
            style="width: 200px;"
          ></el-input>
        </el-col>

        <el-col
          :span="24"
          style="margin-bottom: 10px;"
        >
          <span class="title">起止时间:</span>

          <el-date-picker
            v-model="search_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="timeChange"
          >
          </el-date-picker>
        </el-col>

      </el-row>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchPushLogLists"
      >搜索</el-button>
      <el-button
        icon="el-icon-refresh-right"
        @click="refresh"
      >刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
      @selection-change="handleSelectionChange"
    >

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
          >
            <!-- 表格下拉 -->

            <el-form-item label="关联数据:">
              <span>{{ props.row.relation }}</span>
            </el-form-item>

            <el-form-item label="详细数据:">
              <span>

                {{ props.row.more }}

              </span>
            </el-form-item>

            <el-form-item label="时间:">
              <span>

                {{ props.row.time.Ymd }}

              </span>
            </el-form-item>

            <el-form-item label="详细时间:">
              <span>

                {{ props.row.time.YmdHis }}

              </span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>

      <el-table-column
        prop="id"
        label="id"
      >
      </el-table-column>

      <el-table-column
        prop="phone"
        label="手机号"
      >
      </el-table-column>

      <el-table-column
        prop="consumer_code"
        label="唯一编码"
      >
      </el-table-column>

      <el-table-column
        prop="table_name"
        label="数据表"
      >
      </el-table-column>

      <el-table-column
        prop="description"
        label="描述"
      >
      </el-table-column>

      <el-table-column
        prop="time.YmdHis"
        label="详细时间"
      >
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages
        :search_data="search_data"
        :result_data="result_data"
        @pages_function="pages_function"
      ></pages>
    </div>

  </div>

</template>

<script>
var _this;
export default {
   
    watch: {
        startTime(val) {
            if (val == null) {
                this.search_data.start_time = '';
            }
            console.log(val);
        },
        endTime(val) {
            if (val == null) {
                this.search_data.end_time = '';
            }
        }
    },
    data() {
        return {

            search_time: '',

            delDriverSubmit_rules: {
                driver_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                phone:'',
                fixed_time: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.pushLogLists();
    },

    methods: {
        timeChange(val) {
            if (val !== null) {
                _this.search_data.fixed_time = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_time = '';
            }
        },
        searchPushLogLists() {
            _this.search_data.page = 1;
            _this.pushLogLists();
        },
        // 搜索司机审核列表
        pushLogLists() {
            _this
                .$post('/log/consumerLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.pushLogLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },
        // 是否全部推送下拉选中触发
        allAudienceChange(val) {
            console.log(val);
            _this.search_data.all_audience = val;
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>